<template>
  <div class="wrapper">
    <div class="content">
      <button @click="back" class="button back" type="button">
        <i class="back"></i>
        <span>Back</span>
      </button>
      <div class="details-content">
        <div class="country-flag">
          <img :alt="country.name" :src="country.flag">
        </div>
        <article class="country-info">
          <h1>{{ country.name }}</h1>
          <div class="lists-container">
            <ul>
              <li>
                <span>Native name:</span>
                <span>{{country.nativeName}}</span>
              </li>
              <li>
                <span>Population:</span>
                <span>{{ country.population.toLocaleString() }}</span>
              </li>
              <li>
                <span>Region:</span>
                <span>{{country.region}}</span>
              </li>
              <li>
                <span>Sub Region:</span>
                <span>{{country.subregion}}</span>
              </li>
              <li>
                <span>Capital:</span>
                <span>{{ country.capital }}</span>
              </li>
            </ul>
            <ul>
              <li>
                <span>Top Level Domain:</span>
                <span>{{ topLevelDomain }}</span>
              </li>
              <li>
                <span>Currencies:</span>
                <span>{{currencies}}</span>
              </li>
              <li>
                <span>Languages:</span>
                <span>{{ languages }}</span>
              </li>
            </ul>
          </div>
          <div class="borders-container">
            <h2>Border Countries:</h2>
            <div class="borders-countries">
              <template v-if="!hasBorders">
                <p style="margin-top: 0">No borders</p>
              </template>
              <template v-else>
                <router-link
                    v-for="border in bordersCodes"
                    :key="border"
                    :to="{name: 'details', params:{code: border}}"
                    class="button border"
                >
                  {{ border }}
                </router-link>
              </template>
            </div>
          </div>

        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import '../assets/scss/details-view.scss'
  import {mapActions, mapGetters, mapState} from 'vuex'
  import store from "@/store"

  export default {
    name: "DetailView",
    props: ['code'],
    data() {
      return {}
    },
    methods: {
      back() {
        this.$router.push({name: 'home'})
      },
      ...mapActions([
        'setCountry'
      ])
    },
    async beforeRouteUpdate(to, from, next) {
      try {
        let country = await store.dispatch('fetchCountry', to.params.code)
        to.params.code = country
        next()
      } catch (e) {
        if (e.response && e.response.status == 404) {
          next()
        } else {
          next()
        }
      }
    },
    computed: {
      topLevelDomain() {
        return this.country.topLevelDomain.join(', ')
      },
      currencies() {
        return this.country.currencies
            .map(function (el) {
              return el.name
            }).join(', ')
      },
      languages() {
        return this.country.languages
          .map(function (el) {
            return el.name
          }).join(', ')
      },
      bordersCodes() {
        return this.country.borders
      },
      borders() {
        let borders = []

        this.bordersCodes.forEach(code => {
          borders.push(this.findCountryByCode(code))
        })

        return borders
      },
      hasBorders() {
        return this.bordersCodes.length > 0
      },
      country() {
        return this.code
      },
      ...mapState({
        countries: state => state.countries,
        countryBorders: state => state.countryBorders
      }),
      ...mapGetters([
        'findCountryByCode'
      ])
    }
  }
</script>

<style scoped>

</style>
